import type { LinearFn2d, Point2d } from "."
import { linearFnFromPointSlope } from "./linearFnFromPointSlope"

export const createNormalFn = (
  fn: LinearFn2d,
  { x, y }: Point2d,
): LinearFn2d => {
  const point = {
    x,
    y: isNaN(fn.intercept) || !isFinite(fn.intercept) ? y : fn(x),
  }
  const slope = -1 / fn.slope

  return linearFnFromPointSlope(point, slope)
}

export const createNormalFnAnywhere = (
  fn: LinearFn2d,
  point: Point2d,
): LinearFn2d => {
  const slope = -1 / fn.slope

  return linearFnFromPointSlope(point, slope)
}
